import { Link } from "react-router-dom";
import { Calendar, Clock, ChevronRight } from "lucide-react";
import { useArticleContext } from "../context/ArticleContext";
import { useEffect } from "react";

export default function Articles() {
  // const featuredArticle = articles.find((article) => article.featured);
  // const regularArticles = articles.filter((article) => !article.featured);
  const { articles, fetchArticles} = useArticleContext();

  useEffect(() => {
    fetchArticles();
  }, []);

  return (

    <div className="bg-[#fef8f5]">
      <div
        className="relative h-[40vh] bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1588776814546-ec7d73834fe9?q=80&w=1480&auto=format&fit=crop')",
        }}
      >
        <div className="absolute inset-0 bg-[#fef8f5] opacity-90" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-4xl font-serif font-bold text-[#7a6e5f]">
            Skincare Journal
          </h1>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Featured Article */}
        {/* {featuredArticle && (
          <div className="mb-20">
            <h2 className="text-3xl font-serif font-semibold text-[#7a6e5f] mb-6">
              Featured Article
            </h2>
            <div className="grid md:grid-cols-2 gap-8 bg-white rounded-xl shadow overflow-hidden">
              <div className="relative h-[400px] md:h-auto">
                <img
                  src={featuredArticle.image}
                  alt={featuredArticle.title}
                  className="absolute inset-0 w-full h-full object-cover"
                />
              </div>
              <div className="p-8 flex flex-col justify-between text-[#7a6e5f]">
                <div>
                  <div className="flex items-center gap-4 text-sm mb-4 opacity-80">
                    <div className="flex items-center">
                      <Calendar className="w-4 h-4 mr-2" />
                      {new Date(featuredArticle.date).toLocaleDateString("en-GB")}
                    </div>
                    <div className="flex items-center">
                      <Clock className="w-4 h-4 mr-2" />
                      {featuredArticle.readTime}
                    </div>
                  </div>
                  <h3 className="text-3xl font-serif font-bold mb-4">
                    {featuredArticle.title}
                  </h3>
                  <p className="opacity-80 mb-4">{featuredArticle.excerpt}</p>
                  <p className="text-sm opacity-70">By {featuredArticle.author}</p>
                </div>
                <Link
                  to={`/articles/${featuredArticle.id}`}
                  className="inline-flex items-center text-[#809080] font-semibold hover:underline mt-6"
                >
                  Read Article
                  <ChevronRight className="w-4 h-4 ml-1" />
                </Link>
              </div>
            </div>
          </div>
        )} */}
        
        <div>
          <h2 className="text-3xl font-serif font-semibold text-[#7a6e5f] mb-6">
            Latest Articles
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {articles.slice(0, 6).map((article) => (
              <div
                key={article.id}
                className="bg-white rounded-xl shadow group overflow-hidden flex flex-col"
              >
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={`${process.env.REACT_APP_API_URL}/storage/${article.image}`}
                    alt={article.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6 text-[#7a6e5f] flex flex-col flex-1">
                  <div className="flex items-center gap-4 text-sm opacity-70 mb-3">
                    <div className="flex items-center">
                      <Calendar className="w-4 h-4 mr-2" />
                      {new Date(article.created_at).toLocaleDateString("en-GB")}
                    </div>
                    <div className="flex items-center">
                      <Clock className="w-4 h-4 mr-2" />
                      {article.readTime}
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold mb-2 group-hover:text-[#809080] transition-colors font-serif">
                    {article.title}
                  </h3>
                  <p className="text-sm opacity-80 mb-4 line-clamp-3">
                    {article.excerpt}
                  </p>
                  <div className="flex justify-between items-end mt-auto">
                    <span className="text-sm opacity-70">
                      By {article.author}
                    </span>
                    <Link
                      to={`/articles/${article.id}`}
                      className="text-[#809080] font-medium hover:underline inline-flex items-center"
                    >
                      Read More
                      <ChevronRight className="w-4 h-4 ml-1" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
